import { lazy } from 'react'

import { useRouteMatch } from 'react-router'

import { SpendingCardFundListTabs } from '@webapp/containers/SpendingCardManagementDetailsView/types'
import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { type PayCard } from '@webapp/models'
import { PayCardStatuses } from '@webapp/models/enums'
import { type PayFund } from '@webapp/models/PayFund'
import messages from './messages'

export interface SpendingCardManagementFundDetailsPageParams {
  card: PayCard['external_id']
  fund: PayFund['uuid']
}

const SpendingCardManagementFundDetailsViewChunk = lazy(() =>
  import('../containers/SpendingCardManagementFundDetailsView').then(
    ({ SpendingCardManagementFundDetailsView }) => ({
      default: SpendingCardManagementFundDetailsView,
    })
  )
)

export const SpendingCardManagementFundDetailsPage = () => {
  const intl = useProcurifyIntl()

  const { url } = useAppRoutes()

  const match = useRouteMatch<{
    id: PayCard['external_id']
    fundId: PayFund['uuid']
  }>()

  const cardDetailsPath = url('CardManagementDetailsPage', {
    id: match.params.id,
    fundStatus: SpendingCardFundListTabs.OPEN,
  })

  return (
    <Page
      pageTitle={intl.formatMessage(messages.spendingCardFundDetailsPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.spendingCardManagementTitle),
          link: url('CardManagementPage', {
            status: PayCardStatuses.ACTIVE,
          }),
        },
        {
          name: intl.formatMessage(
            messages.spendingCardManagementDetailsPageTitle
          ),
          link: cardDetailsPath,
        },
        {
          name: intl.formatMessage(messages.spendingCardFundDetailsPageTitle),
        },
      ]}
    >
      <SpendingCardManagementFundDetailsViewChunk />
    </Page>
  )
}
